function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgviewerMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D3D4"
    },
    d: "M180.648,511.479H60.366c-11.705,0-21.194-9.489-21.194-21.194V194.56 c0-11.705,9.489-21.194,21.194-21.194h74.687c9.16,0,17.284,5.885,20.138,14.59c57.06,174.012,46.651-7.038,46.651,302.329 C201.842,501.989,192.353,511.479,180.648,511.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M159.454,511.479V297.788c0-9.782,6.693-18.292,16.199-20.598 c23.681-5.731,20.609,11.716,80.346,112.323c58.561-98.631,23.524-106.583,210.827,85.993c6.861,7.056,8.073,18.064,2.42,26.577 C460.448,515.33,472.766,511.479,159.454,511.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M466.826,475.508c-186.77-192.029-151.829-185.357-210.827-85.995v121.965 c210.927,0,204.672,3.515,213.246-9.395C474.899,493.573,473.687,482.563,466.826,475.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F59D00"
    },
    d: "M436.44,505.061C282.004,346.278,280.607,351.584,288.061,333.935 c7.294-17.269,10.661-12.948,163.571-12.948c11.705,0,21.194,9.489,21.194,21.194v148.104 C472.827,509.321,449.625,518.62,436.44,505.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57BDB7"
    },
    d: "M472.827,363.376c-179.701,0-171.824,2.283-180.227-6.194 c-23.398-23.607,26.316-53.633,64.226-169.284c2.847-8.685,10.978-14.531,20.12-14.531h74.687c11.705,0,21.194,9.489,21.194,21.194 L472.827,363.376L472.827,363.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M255.999,0c-95.69,0-177.366,90.591-141.083,201.164c23.124,70.529,87.293,183.229,123.115,240.494 c3.874,6.194,10.665,9.955,17.97,9.955c7.305,0,14.095-3.763,17.97-9.955c25.072-40.082,97.496-162.393,123.115-240.491v0.001 C433.227,90.997,352.013,0,255.999,0z M255.998,226.722c-41.711,0-75.645-33.94-75.645-75.659c0-41.711,33.936-75.647,75.645-75.647 c41.711,0,75.647,33.934,75.647,75.647C331.645,192.781,297.71,226.722,255.998,226.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M255.999,0v75.416c41.711,0.001,75.645,33.936,75.645,75.647c0,41.718-33.934,75.658-75.645,75.659 v224.891c7.305,0,14.094-3.763,17.968-9.955c25.072-40.082,97.496-162.393,123.115-240.491v0.001 C433.227,90.997,352.013,0,255.999,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgviewerMaps);
export default __webpack_public_path__ + "static/media/svgviewer-maps.1d1ed4bae0093c7df95fead65e2d7fff.svg";
export { ForwardRef as ReactComponent };